import React, { useState, useEffect, useReducer } from 'react';
import { FormattedMessage } from 'react-intl';
import SVG from 'react-inlinesvg';
import BootstrapTable from 'react-bootstrap-table-next';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar,
} from '../../../../../../../_metronic/_partials/controls';
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
} from '../../../../../../../_metronic/_helpers';
import Numeric from '../../../../../../components/Numeric';
import axios, { baseUrl } from '../../../../../../../redux/my-axios';
import * as columnFormatters from '../../../../../../components/SelectProduct/List/column-formatters';

export const ITEMS_URL = '/boxitems';
function reducer(state, action) {
  switch (action.type) {
    case 'init':
      let wei0 = parseFloat('0.00');
      return {
        items: action.payload.items.map((item) => {
          let box = action.payload.box;
          let weight = parseFloat(item.weightValue);
          let totalWeightVal =
            Math.round((weight * item.productQuantity + Number.EPSILON) * 100) /
            100;
          let cargoCostVal =
            Math.round(
              ((weight * box.cargoCostMnt) / box.weight + Number.EPSILON) * 100
            ) / 100;
          let boxTotalCost = box.totalCost ? parseFloat(box.totalCost) : 1;
          let itemCustomTax = item.customTax
            ? parseFloat(item.customTax)
            : Math.round(
                ((item.productCost * parseFloat(box.customTaxAmount)) /
                  boxTotalCost +
                  Number.EPSILON) *
                  100
              ) / 100;
          let totalCost =
            Math.round(
              (itemCustomTax +
                cargoCostVal +
                parseFloat(item.productCost) +
                Number.EPSILON) *
                100
            ) / 100;
          wei0 = wei0 + totalWeightVal;
          const updatedItem = {
            ...item,
            customTax: itemCustomTax,
            cargoCost: cargoCostVal,
            totalWeight: totalWeightVal,
            totalCost: totalCost,
          };
          return updatedItem;
        }),
        calcWeight: Math.round((wei0 + Number.EPSILON) * 100) / 100,
      };
    case 'setWeight':
      let wei = parseFloat('0.00');
      return {
        items: state.items.map((item) => {
          if (item.productCode === action.payload.product.productCode) {
            let weight = parseFloat(action.payload.newWeight);
            let totalWeightVal =
              Math.round(
                (weight * action.payload.product.productQuantity +
                  Number.EPSILON) *
                  100
              ) / 100;
            wei = wei + totalWeightVal;
            console.log('totalWeight=', totalWeightVal);
            //console.log('weight=', weight);
            let cargoCostVal =
              Math.round(
                ((weight * action.payload.box.cargoCostMnt) /
                  action.payload.box.weight +
                  Number.EPSILON) *
                  100
              ) / 100;
            console.log('cargoCostVal=', cargoCostVal);
            let customCost = item.customTax
              ? parseFloat(item.customTax)
              : parseFloat('0.00');
            let totalCost =
              Math.round(
                (customCost +
                  cargoCostVal +
                  item.productCost +
                  Number.EPSILON) *
                  100
              ) / 100;
            console.log('totalCost', totalCost);
            const updatedItem = {
              ...item,
              weightValue: weight,
              totalWeight: totalWeightVal,
              cargoCost: cargoCostVal,
              totalCost: totalCost,
            };

            return updatedItem;
          } else wei = wei + item.totalWeight;

          return item;
        }),
        calcWeight: Math.round((wei + Number.EPSILON) * 100) / 100,
      };
    default:
      console.log('Wrong Dispatch: ', action);
  }
}
export default function BoxItems(props) {
  const { box, saveBoxItems } = props;
  const [err, setError] = useState('');
  const [msg, setMsg] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [state, dispatch] = useReducer(reducer, { items: [] });

  const columns = [
    {
      dataField: 'icon',
      text: '',
      sort: false,
      style: {
        width: '65px',
      },
      formatter: columnFormatters.IconColumnFormatter,
    },
    {
      dataField: 'name',
      text: 'Name',
      sort: false,
      formatter: columnFormatters.NameColumnFormatter,
    },

    {
      dataField: 'productQuantity',
      text: 'Qty',
      sort: false,
      //formatter: ProductQuantityColumnFormatter,
      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      style: {
        minWidth: '60px',
        width: '70px',
      },
    },
    {
      dataField: 'productPrice',
      text: 'Unit Price',
      sort: false,
      formatter: DecimalColumnFormatter,
      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      style: {
        minWidth: '60px',
        width: '80px',
      },
    },
    {
      dataField: 'productCost',
      text: 'Product Cost',
      sort: false,
      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      formatter: DecimalColumnFormatter,
      style: {
        minWidth: '100px',
        width: '100px',
      },
    },
    {
      dataField: 'weightValue',
      text: 'Weight',
      sort: false,
      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      formatter: WeightColumnFormatter,
      style: {
        minWidth: '60px',
        width: '80px',
      },
    },
    {
      dataField: 'totalWeight',
      text: 'Total Weight',
      sort: false,
      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      formatter: TotalWeightColumnFormatter,
      style: {
        minWidth: '60px',
        width: '80px',
      },
    },
    {
      dataField: 'cargoCost',
      text: 'Cargo Cost',
      sort: false,
      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      formatter: DecimalColumnFormatter,
      style: {
        minWidth: '60px',
        width: '80px',
      },
    },

    {
      dataField: 'customTax',
      text: 'Custom Tax',
      sort: false,
      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      formatter: DecimalColumnFormatter,
      style: {
        minWidth: '60px',
        width: '80px',
      },
    },
    {
      dataField: 'totalCost',
      text: 'Total Cost',
      sort: false,
      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      formatter: DecimalColumnFormatter,
      style: {
        minWidth: '60px',
        width: '80px',
      },
    },
    {
      dataField: 'action',
      text: '',
      //formatter: ActionsColumnFormatter,

      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      style: {
        minWidth: '50px',
      },
    },
  ];

  useEffect(() => {
    setLoading(true);
    axios
      .post(
        ITEMS_URL,
        { orderCode: box.orderCode, trackingId: box.trackingId },
        { headers: { action: 'get' } }
      )
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            //console.log('BoxItems: ', response.data.data);
            setTotalCount(response.data.data.length);
            dispatch({
              type: 'init',
              payload: { items: response.data.data, box: box },
            });
            setLoading(false);
            break;
          default:
            var error = response.data.msg.desc;
            setError(error);
            setLoading(false);
            break;
        }
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, [box]);

  useEffect(() => {
    console.log('STATE', state);
  }, [state]);

  const save = () => {
    setLoading(true);
    axios
      .post(
        ITEMS_URL,
        {
          orderCode: box.orderCode,
          trackingId: box.trackingId,
          items: state.items,
        },
        { headers: { action: 'set' } }
      )
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
            setError('');
            setMsg('Амжилттай хадгаллаа');
            setLoading(false);
            saveBoxItems();
            break;
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            //console.log('set items: ', response.data.data);
            setError('');
            setMsg(response.data.data);
            setLoading(false);
            saveBoxItems();
            break;
          default:
            var error = response.data.msg.desc;
            setMsg('');
            setError(error);
            setLoading(false);
            break;
        }
      })
      .catch((error) => {
        setMsg('');
        setError(error);
        setLoading(false);
      });
  };

  const setWeight = (row, e) => {
    dispatch({
      type: 'setWeight',
      payload: { product: row, box: box, newWeight: e },
    });
  };

  function WeightColumnFormatter(cellContent, row) {
    return (
      <Numeric
        key={`productWeight_${row.productCode}`}
        name='weight'
        value={cellContent}
        onBlur={(e) => {
          setWeight(row, e);
        }}
        /*         onChange={(e) => {
          onChangePriceVal(row.productCode, e);
        }} */
        className='form-control form-control-sm'
        negative={false}
        prefix=''
        decimalScale='3'
        fixedDecimalScale={true}
      />
    );
  }

  function TotalWeightColumnFormatter(cellContent, row) {
    return <div>{cellContent ? cellContent : '0.00'}</div>;
  }

  function DecimalColumnFormatter(cellContent, row) {
    return (
      <div>
        {cellContent
          ? cellContent
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
          : '0.00'}
      </div>
    );
  }

  return (
    <div>
      {err ? (
        <div className='mb-10 alert alert-custom alert-light-danger alert-dismissible'>
          <div className='alert-text font-weight-bold'>{err}</div>
        </div>
      ) : (
        <div></div>
      )}
      {msg ? (
        <div className='mb-10 alert alert-custom alert-light-info alert-dismissible'>
          <div className='alert-text font-weight-bold'>{msg}</div>
        </div>
      ) : (
        <div></div>
      )}

      <Card id='boxItemsCard'>
        {loading && <ModalProgressBar />}
        <CardHeader title={`Items - ${totalCount} `}>
          <CardHeaderToolbar>
            <>
              {box && box.weight === state.calcWeight ? (
                <span style={{ color: 'blue' }}>{state.calcWeight}</span>
              ) : (
                <span style={{ color: 'red' }}>{state.calcWeight}</span>
              )}
              <button
                type='button'
                className='btn btn-info ml-2'
                onClick={save}
              >
                <FormattedMessage id='GENERAL.BUTTON.SAVE' />
                {loading && (
                  <span
                    id='orderItemsSave'
                    className='ml-3 spinner spinner-white '
                  ></span>
                )}
              </button>
            </>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <BootstrapTable
            wrapperClasses='table-responsive'
            classes='table table-head-custom table-vertical-center overflow-hidden'
            bootstrap4
            bordered={false}
            local
            keyField='productCode'
            data={state.items === null ? [] : state.items}
            columns={columns}
          >
            <PleaseWaitMessage entities={state.items} />
            <NoRecordsFoundMessage entities={state.items} />
          </BootstrapTable>
        </CardBody>
      </Card>
    </div>
  );
}
